export default __webpack_public_path__ + "static/hotel-lead-a6700a09f0616b147d2c55da6cec080f.png";